import { ModuleWithProviders, NgModule } from '@angular/core';
import { SHARED_ENVIRONMENT } from './environment.token';

@NgModule({})
export class EnvironmentModule {
  public static withEnvironment<EnvironmentType>(
    environment: EnvironmentType,
  ): ModuleWithProviders<EnvironmentModule> {
    const sharedEnvironment = {
      provide: SHARED_ENVIRONMENT,
      useValue: { ...environment },
    };
    return {
      ngModule: EnvironmentModule,
      providers: [sharedEnvironment],
    };
  }
}
